import React from "react";

import { Tooltip, Checkbox, Icon, IconBox } from "@proda-ai/ui-kit";

import Box from "@/ui/atoms/Box";

import type { IHeaderParams } from "@/ui/molecules/Grid";

export const testIds = {
    main: "GridDuplicateHeaderComponent",
    currentExtractionBadge:
        "GridDuplicateHeaderComponent-currentExtractionBadge",
    checkbox: "GridDuplicateHeaderComponent-checkbox",
    label: "GridDuplicateHeaderComponent-label",
};

export const GridDuplicateHeaderComponent = (
    props: IHeaderParams & {
        selectedValue: string;
        tooltipContent: React.ReactNode;
        groupHeaderName: string;
        isAltered?: boolean;
        isCurrent?: boolean;
        onChangeActiveColumn: (columnId: string) => void;
    },
) => {
    const {
        tooltipContent,
        displayName,
        selectedValue,
        column,
        groupHeaderName,
        onChangeActiveColumn,
        isCurrent,
        isAltered,
    } = props;

    return (
        <Tooltip
            content={tooltipContent}
            style={{
                maxWidth: "100%",
                height: "100%",
                width: "100%",
                gap: 0.5,
            }}
        >
            <Box
                data-testid={testIds.main}
                data-group-header-name={groupHeaderName}
                sx={{
                    color: "var(--text-color-dark) !important",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    maxWidth: "100%",
                    gap: 0.5,
                    height: "100%",
                    width: "100%",
                }}
            >
                {(isCurrent === true || isAltered === true) && (
                    <IconBox
                        style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-2px",
                            transform: "rotate(-135deg)",
                        }}
                        data-testid={testIds.currentExtractionBadge}
                    >
                        <Icon
                            icon="caret-down"
                            size="lg"
                            color={
                                isCurrent === true
                                    ? "var(--proda-celtic-blue)"
                                    : "var(--proda-purple)"
                            }
                        />
                    </IconBox>
                )}
                <Checkbox
                    data-testid={testIds.checkbox}
                    hideLabel
                    label={displayName}
                    value={column.getColId()}
                    checked={selectedValue === column.getColId()}
                    onChange={() => onChangeActiveColumn(column.getColId())}
                />
                <Box
                    data-testid={testIds.label}
                    component="label"
                    htmlFor={displayName}
                    sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        flexGrow: 1,
                    }}
                >
                    {displayName}
                </Box>
            </Box>
        </Tooltip>
    );
};

export default GridDuplicateHeaderComponent;
